export const usePricingData = [
    {
        title: 'Basic Plan',
        description: 'Access to core features, easy crosspromotions management',
        icon: 'pricingcard1',
        action: {
            type: 'outline',
            color: '#718096',
            background: 'none',
            text: 'Get Started' 
        },
        options: [
            {
                text: "Full access to cross-promotion friendly campaigns' database",
                tooltip: null
            },
            {
                text: "Unlimited messages and requests",
                tooltip: null
            },
            {
                text: "Multiple campaign management",
                tooltip: null
            },
            {
                text: "1 automatic draft post to Kickstarter",
                tooltip: "With a single click, save your update post draft with information about your partners straight into Kickstarter!"
            },
        ]
    },
    {
        title: 'Premium',
        description: 'Essentials for crosspromotion pros',
        icon: 'pricingcard2',
        action: {
            type: 'fill',
            color: '#ffffff',
            background: '#727CF5',
            text: 'Get Started'
        },
        options: [
            {
                text: "Full access to cross-promotion friendly campaigns' database",
                tooltip: null
            },
            {
                text: "Unlimited messages and requests",
                tooltip: null
            },
            {
                text: "Multiple campaign management",
                tooltip: null
            },
            {
                text: "Unlimited automatic draft post to Kickstarter",
                tooltip: "With a single click, save your update post draft with information about your partners straight into Kickstarter! Unlimited with Premium plan."
            },
            {
                text: 'Get "Featured" for 5 days',
                tooltip: 'Instantly appear in the "Featured" section on our homepage, and get 40% more requests!'
            },
            {
                text: 'Unique tracking link generation',
                tooltip: 'Get exact analytic data about how much traffic and revenue you got from each crosspromotion.'
            },
            {
                text: "Facebook pixel integration - Kickstarter audience retargeting option",
                tooltip: 'Create an audience from the traffic CrossProm generated to your campaign.'
            },
        ]
    },
    {
        title: 'VIP',
        description: 'Your cross-promotion campaign fully managed by our team',
        icon: 'pricingcard3',
        action: {
            type: 'fill-next',
            color: '#ffffff',
            background: '#0ACF97',
            text: 'Contact Us'
        },
        options: [
            {
                text: "Personal campaign manager",
                tooltip: "Individual cross-promotions manager will arrange cross-promotions over the period of the campaign."
            },
            {
                text: "Guaranteed cross promotions for your updates",
                tooltip: 'The manager will make sure that your campaign is posted in relevant updates and will transfer you information to be posted in your update.'
            },
            {
                text: "Performance based payment",
                tooltip: 'We will only charge a percentage from the funds we raised for you through cross-promotions.'
            },
        ]
    },
] 